import React from 'react';
import { useNamespacedTranslation } from '../../../../../hooks/useNamespacedTranslation';

const i18Prefix = 'documents2.documentPreview';

type Props = {
  url: string;
  width: string | number;
  onLoad: () => void;
};

// position-absolute gives the frame its own scrolling, independent of the
// panel it sits in.
export const PreviewFrame: React.FC<Props> = ({ url, width, onLoad }) => {
  const t = useNamespacedTranslation(i18Prefix);

  return (
    <iframe
      onLoad={onLoad}
      className="position-absolute top-0 left-0 border-end"
      height="100%"
      width={width}
      src={url}
      title={t('previewTitle')}
    />
  );
};
